import { z } from 'zod';
import { BaseErrorSchema } from 'libs/end-to-end/src/types/errors/base-error-schema';

export const S3StorageSignUploadUrlError = BaseErrorSchema.extend({
  errorType: z.literal('S3StorageSignUploadUrlError'),
  bucketName: z.string(),
  bucketRegion: z.string(),
  key: z.string(),
  errorReason: z.string(),
});

export type S3StorageSignUploadUrlError = z.infer<
  typeof S3StorageSignUploadUrlError
>;
